export enum userListActiontype {
    FETCH_USER_LIST = "fetch_user_list",
    FETCH_USER_LIST_SUCCESS = "fetch_user_list_success",
    FETCH_USER_LIST_FAILURE = "fetch_user_list_failure",
  }
  